<template>
  <pt-video-form class="pt-video-form__page"></pt-video-form>
</template>

<script>
import PtVideoForm from 'cps/tool-operation/pt-video-manage/pt-video-form/withData'
export default {
  name: 'pt-video-form__view',
  components: {
    'pt-video-form': PtVideoForm
  }
}
</script>
